import autosize from 'autosize';

export default () => {
    return {
        error: false,
        errors: [],
        sending: false,
        success: false,
        textarea: null,
        init() {
            this.textarea = this.$refs.form.querySelectorAll('textarea')
            autosize(this.textarea);
        },
        send() {
            this.sending = true;
            fetch(this.$refs.form.action, {
                headers: { 'X-Requested-With' : 'XMLHttpRequest' },
                method: 'POST',
                body: new FormData(this.$refs.form)})
            .then(res => res.json())
            .then(json => {
                if (json['success']) {
                    this.errors = [];
                    this.success = true;
                    this.error = false;
                    this.sending = false;
                    this.$refs.form.reset();
                    autosize.update(this.textarea);
                }
                if (json['error']) {
                    console.error(json['error']);
                    this.sending = false;
                    this.error = true;
                    this.success = false;
                    this.errors = json['error'];
                }
            })
            .catch(err => {
                this.sending = false
                console.error(err)
            })
        },
    }
}
